/**
 * created by qdshen on 2020/02/14
 * 全局过滤器
 */
import Vue from 'vue';

// 党建宣传 - 审批状态
Vue.filter('appStatus', (val) => {
    switch (val) {
        case '0':
            return '未审核'
            break;
        case '1':
            return '审核通过'
            break;
        case '2':
            return '审核拒绝'
            break;
    }
});
// 组织生活 - 一级分类
Vue.filter('firstTypeStatus', (val) => {
    switch (val) {
        case '1':
            return '三会一课'
            break;
        case '2':
            return '两学一做'
            break;
        case '3':
            return '组织生活会'
            break;
        case '4':
            return '其他'
            break;
    }
});
// 组织生活 - 二级分类
Vue.filter('secondTypeStatus', (val) => {
    switch (val) {
        case '1':
            return '支部委员大会'
            break;
        case '2':
            return '支部委员会'
            break;
        case '3':
            return '党小组会'
            break;
        case '4':
            return '按时上好党课'
            break;
    }
});
//投诉与建议
Vue.filter('cljgStatus', (val) => {
    switch (val) {
        case '0':
            return '未处理'
            break;
        case '1':
            return '处理中'
            break;
        case '2':
            return '已处理'
            break;
    }
});
//反馈类别
Vue.filter('fklbStatus', (val) => {
    switch (val) {
        case '0':
            return '投诉'
            break;
        case '1':
            return '建议'
            break;
    }
});
//处理结果评价
Vue.filter('jgpjStatus', (val) => {
    switch (val) {
        case '0':
            return '待评价'
            break;
        case '1':
            return '不满意'
            break;
        case "2":
            return "满意"
            break;
        case "3":
            return "很满意"
            break;
    }
});
// 地址市区拼接
Vue.filter('mapAddressAreaFilter', (item) => {

    let detail = ''
    if (item.cityName) {
        detail += item.cityName
    }
    if (item.areaName) {
        detail += item.areaName
    }
    if (item.streetName) {
        detail += item.streetName
    }
    detail = detail ? detail : '暂无';
    return detail

});

// 将时间戳转化成 2018-03-08 15:25:00
// Vue.filter('formatTime', (value, param) => {
//     if(!value){
//       return '';
//     }
//     else{
//       let time = new Date(value);
//       let year = time.getFullYear();
//       let month = time.getMonth() + 1;
//       month = month < 10 ? '0' + month : month;
//       let date = time.getDate();
//       date = date < 10 ? '0' + date : date;
//       let hour = time.getHours();
//       hour = hour < 10 ? '0' + hour : hour;
//       let min = time.getMinutes();
//       min = min < 10 ? '0' + min : min;
//       let sec = time.getSeconds();
//       sec = sec < 10 ? '0' + sec : sec;
//       return `${year}-${month}-${date} ${hour}:${min}:${sec}`;
//     }

// });

Vue.filter('formatDates', (value, param) => {
    param = param || 'yyyy-MM-dd'
    if (!value) {
        return '';
    } else {
        return new Date(value).Format(param);;
    }

});